export const DRIVERS_LICENSE_DESCRIPTION =
  "Collect a driver's license for your records and low-friction compliance. Our AI confirms the document is a license, checks that it is not expired, and matches the name to the contractor's profile.";

export const DRIVERS_LICENSE_DISCLAIMER =
  "This recipe is designed for record-keeping and is not a substitute for high-assurance, biometric identity verification.";

export const DRIVERS_LICENSE_COST = "$1.99 per verification";

export const DRIVERS_LICENSE_INSTRUCTIONS = `### **Requirement guide for driver's license**
Upload a digital copy of your driver's license. Make sure all information is legible and matches the verification requirements below.

**Upload driver's license:**

- **Prepare your file**
  - Have a clear digital copy ready.
  - Check that all text is legible.
  - Review the verification details below to confirm your driver's license meets the requirements.

- **Upload your file**
  - Upload your file when you continue to the next page.

- **Accepted formats:**
  - Document (pdf)
  - Image (jpeg, png, webp, heic, heif)
  - Max 100MBs per file
`;

export const DRIVERS_LICENSE = {
  instructions: DRIVERS_LICENSE_INSTRUCTIONS,
  description: DRIVERS_LICENSE_DESCRIPTION,
  disclaimer: DRIVERS_LICENSE_DISCLAIMER,
  cost: DRIVERS_LICENSE_COST
};
